import Alpine from "alpinejs";
import { ajaxify } from "./Ajaxify.js";

Alpine.data("fetch", (url, remove = true, replace = false) => ({
    init() {
        const element = this.$el;
        const target = this.$refs.target || element;
        ajaxify({
            url,
            element,
            target,
            remove,
            replace,
        });
    },
}));
